(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsEmailTemplate', rmsEmailTemplateComponent);

    function rmsEmailTemplateComponent(lodash) {
        return {
            retrict: 'E',
            scope: {
                options: '=',
            },
            require: 'ngModel',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return 'common/app/components/email-template/' + attrs.template;
                }

                return 'common/app/components/email-template/index-email-template';
            },
            controller: rmsEmailTemplateComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, iElement, iAttrs, ngModelCtrl) {
                var vm = scope.vm;

                ngModelCtrl.$render = function() {
                    vm.model = ngModelCtrl.$viewValue;
                };

                scope.$watch(function() {
                    return lodash.isEqual(vm.model,ngModelCtrl.$viewValue);
                }, function() {
                    ngModelCtrl.$setViewValue(vm.model);
                });
            },
        };
    }

    function rmsEmailTemplateComponentCtrl(GenericModel, EmailTemplateService, lodash, $scope, $timeout, $element) {
        var vm = this;

        this.$onInit = function() {
            vm.getInstance = getInstance;
            vm.handlePlaceholder = handlePlaceholder;
            vm.generateToolTipPlaceholder = generateToolTipPlaceholder;
            vm.getLastActiveEditor = getLastActiveEditor;

            init();
        }

        function init() {
            // ajax calls
            getTemplateTypes();

            // init SODTMCESubjectOptions
            initSODTMCESubjectEditor();

            // watchers
            watchTemplateType();

            // set TemplateType Selectize
            vm.templateTypeSelectizeConfig = {
                create: false,
                valueField: 'value',
                labelField: 'label',
                searchField: 'label',
                delimiter: '|',
                placeholder: '',
                maxItems: 1,
            };
            vm.templateTypeSelectizeOptions = [];
            vm.templatePlaceholders = [];

            // set tinyMCE
            const additional = generateAdditional();
            const cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');
            additional.setup = function(editor) {
                vm.tinyMceInst = editor;
                editor.on('init', function () {
                    $timeout(function () {
                        var em = $element.find('.mce-toolbar-grp');
                        $element.remove('.mce-toolbar-grp');
                        $element.find('.mce-edit-area').after(em);
                    });
                });
                editor.on('Blur', function (e) {
                    setLastActiveEditor(vm.getInstance());
                });

                editor.on('ExecCommand', function(e) {
                    const command = e.value;
                    const execCommandOption = lodash.get(vm, 'options.messageInput.tinyMCEAdditionalOptions.execCommandOption', []);
                    const foundCommand = lodash.find(execCommandOption, { command: command });

                    if (foundCommand) {
                        const node = editor.selection.getNode();

                        const criteria = lodash.get(foundCommand, 'criteria', []);
                        const transformedCriteria = lodash.map(criteria, function (singleCriteria) {
                            const property = lodash.get(singleCriteria, 'property', undefined);

                            const conditionType = lodash.get(singleCriteria, 'condition.type', '');
                            const conditionRegex = lodash.get(singleCriteria, 'condition.regex', '');

                            switch (conditionType) {
                                case 'string':
                                    return (new RegExp(conditionRegex)).test(node[property]);
                            }
                        });
                        const passedCriteria = lodash.every(transformedCriteria, Boolean);

                        if (passedCriteria) {
                            const run = lodash.get(foundCommand, 'run', []);

                            lodash.forEach(run, function (singleRun) {
                                const type = lodash.get(singleRun, 'type', '');

                                switch(type) {
                                    case 'style':
                                        const value = lodash.get(singleRun, 'value', '');
                                        const className = lodash.get(singleRun, 'className', '');
                                        const camelCasedClassName = lodash.camelCase(className);

                                        const hasValueBeenSet = node.style[camelCasedClassName] === value;
                                        tinymce.DOM.setStyle(node, className, hasValueBeenSet ? '' : value);
                                        break;
                                }
                            });
                        }
                    }
                });
            };
            additional.content_css = cdnEp + '/assets/css/rms-tinymce.css';
            additional.body_class = 'activity-description-input';

            const remoteOptions = lodash.get(vm, 'options.messageInput', {});
            const defaultOptions = EmailTemplateService.getDefaultTinyMCEOptions();
            vm.tmceOptions = angular.merge({}, defaultOptions, remoteOptions, additional);
        }

        function generateAdditional() {
            const result = {};

            if (lodash.has(vm, 'options.messageInput.tinyMCEAdditionalOptions')) {
                const defaultOptions = EmailTemplateService.getDefaultTinyMCEOptions();
                const messageInputNested = lodash.get(vm, 'options.messageInput.tinyMCEAdditionalOptions');

                if (lodash.has(messageInputNested, 'plugins')) {
                    const defaultPlugins = defaultOptions.plugins.split(' ');
                    const additionalPlugins = lodash.get(messageInputNested, 'plugins');

                    const mergesPlugins = lodash.concat(defaultPlugins, additionalPlugins);
                    result.plugins = mergesPlugins.join(' ');
                }

                if (lodash.has(messageInputNested, 'toolbar')) {
                    const defaultToolbarSections = defaultOptions.toolbar.split(' | ');
                    const defaultToolbar = lodash.map(defaultToolbarSections, function (defaultToolbarSection) {
                        return defaultToolbarSection.split(' ');
                    });
                    const additionalToolbar = lodash.get(messageInputNested, 'toolbar');

                    const mergesToolbar = lodash.concat(defaultToolbar, additionalToolbar);
                    const joinedMergesToolbarSections = lodash.map(mergesToolbar, function (singleMergesToolbar) {
                        return singleMergesToolbar.join(' ');
                    });
                    const joinedMergesToolbar = joinedMergesToolbarSections.join(' | ');
                    result.toolbar = joinedMergesToolbar;

                    // loading of available templates without the content
                    const hasSODTemplateType = joinedMergesToolbar.indexOf('SODTemplateType') >= 0;
                    const hasSodTemplate = lodash.has(vm, 'options.sodTemplates.datasource.getEmailTemplatesWithType.url');
                    if (hasSODTemplateType && hasSodTemplate) {
                        callRemoteApi(lodash.get(vm, 'options.sodTemplates.datasource.getEmailTemplatesWithType'))
                            .then(function (res) {
                                populateSODTemplateType(res);
                            });
                    }
                }
            }

            return result;
        }

        function initSODTMCESubjectEditor() {
            vm.SODTMCESubjectOptions = {
                plugins: ['noneditable', 'paste'],
                menubar: false,
                toolbar: false,
                preview_styles: false,
                resize: false,
                statusbar: false,
                autoresize_bottom_margin: 0,
                paste_as_text: true,
                content_style: '.mceNonEditable { line-height: 1em; text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; }',
                noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*s>([\s\w]*)<\/u>/g],
                // paste_preprocess: function (plugin, args) {
                //     console.log('paste_preprocess');
                //     var html_content = args.content;
                //
                //     var unclean_dom = $('<div />').html(html_content);
                //     unclean_dom.find('*').removeAttr('class').removeAttr('id');
                //     var replace_html_value = unclean_dom.html();
                //
                //     args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
                // },
                setup: function(editor) {
                    vm.tinyMceSubjectInst = editor;
                    editor.SODTMCESubject = true;

                    editor.on('Blur', function (e) {
                        setLastActiveEditor(getSODTMCESubjectEditor());
                    });

                    var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
                    editor.on('keydown', function (e) {
                        if(e.keyCode == 13){
                            e.preventDefault();
                        }
                        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
                        var len = editor.contentDocument.body.innerText.length;
                        if (len + 1 > this.settings.max_chars) {
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        }
                        return true;
                    });
                },
            };
        }

        function getInstance() {
            return vm.tinyMceInst;
        }

        function getSODTMCESubjectEditor() {
            return vm.tinyMceSubjectInst;
        }

        function getLastActiveEditor() {
            return vm.lastActiveEditor || getInstance();
        }

        function setLastActiveEditor(lastActiveEditor) {
            vm.lastActiveEditor = lastActiveEditor;
        }

        function watchTemplateType() {
            $scope.$watch(function () {
                return lodash.get(vm, 'model[' + lodash.get(vm, 'options.field_map.template_type') + ']', undefined);
            }, function () {
                setTemplateType();
            });
        }

        function setTemplateType() {
            $timeout(function () {
                $scope.$apply(function() {
                    const templateTypeValue = lodash.get(vm, 'model[' + lodash.get(vm, 'options.field_map.template_type') + ']', undefined);
                    const foundTemplateTypeObject = lodash.find(vm.templateTypeSelectizeOptions, { value: parseInt(templateTypeValue) });
                    vm.templatePlaceholders = lodash.values(lodash.get(foundTemplateTypeObject, 'placeholders', {}));
                });
            }, 100);
        }

        function getTemplateTypes() {
            const templateTypeDs = lodash.get(vm, 'options.datasource.email_template_type_list', {});

            vm.fetchingTemplateType = true;
            callRemoteApi(templateTypeDs)
                .then(function (data) {
                    vm.fetchingTemplateType = false;

                    vm.templateTypeSelectizeOptions = data;
                    setTemplateType();
                })
                .catch(function (error) {
                    vm.fetchingTemplateType = false;

                    console.error(error);
                });
        }

        function handlePlaceholder(placeholder) {
            const editor = getLastActiveEditor();
            editor.insertContent(
                [
                    '<span class="mceNonEditable" data-id="' + placeholder.value +  '">',
                    placeholder.label,
                    '</span>'
                ].join('')
            );
        }

        function generateToolTipPlaceholder() {
            return [
                '<div class="tooltip-tag">',
                '<div class="tooltip-tag_header">',
                'Applicant Name',
                '</div>',
                '<div class="tooltip-tag_content">',
                '<p>Tool tip description on how to use</p>',
                '<p><b>For Example: </b></p>',
                '<p><i>John Doe</i></p>',
                '</div>',
                '</div>',
            ].join('');
        }

        function callRemoteApi(datasource, postData) {
            var model = new GenericModel(datasource.url);
            var method = lodash.get(datasource, 'method', 'get');

            var queries = postData;
            var params = {};

            if (method !== 'get') {
                queries = {};
                params = {
                    data: postData,
                }
            }

            return model[method](queries, params).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    if (lodash.has(res, 'selected')) {
                        vm.modelContent = res.selected;
                        vm.ngModelCtrl.$setViewValue(res.selected);
                    }
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function(res) {
                console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();